var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 16C7.71662 16 7.47913 15.9042 7.28746 15.7125C7.09579 15.5208 6.99996 15.2833 6.99996 15V9L1.19996 1.6C0.949958 1.26667 0.912458 0.916667 1.08746 0.55C1.26246 0.183333 1.56662 0 1.99996 0H16C16.4333 0 16.7375 0.183333 16.9125 0.55C17.0875 0.916667 17.05 1.26667 16.8 1.6L11 9V15C11 15.2833 10.9041 15.5208 10.7125 15.7125C10.5208 15.9042 10.2833 16 9.99996 16H7.99996ZM8.99996 8.3L13.95 2H4.04996L8.99996 8.3Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b548c82259b894eaa90c2a1ac23676d7.svg";
export { ForwardRef as ReactComponent };